<template>
  <view-container :col="12">
    <br />
    <h2 style="color: #005591" class="text-center" v-text="'Perfil'" />
    <br />
    <v-card :height="100 + 'vh'" class="mx-auto " color="white" tile>
      <v-row>
        <v-col align="center" cols="3">
          <v-avatar class="" size="90" tile>
            <v-img :src="items.imgURI ? host + items.imgURI : userImg"></v-img>
          </v-avatar>
        </v-col>
        <v-col class="float-left">
          <span
            color="primary"
            class="font-weight-bold primary--text"
            v-text="items.login ? 'Usuario:' : 'Numero de empleado:'"
          />
          <p color="primary" v-text="'*****'" style="margin: 0px" />
          <span
            color="primary"
            class="font-weight-bold primary--text"
            v-text="'Nombre:'"
          />
          <p
            color="primary"
            v-text="
              items.nombre +
                ' ' +
                items.apellidoPaterno +
                ' ' +
                items.apellidoMaterno
            "
            style="margin: 0px"
          />
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12" style="margin-left: 5vh">
          <p color="primary">
            <span
              color="primary"
              class="font-weight-bold primary--text"
              v-text="'Puesto: '"
            />
            {{ items.puesto }}
          </p>
          <p color="primary">
            <span
              color="primary"
              class="font-weight-bold primary--text"
              v-text="'Correo: '"
            />
            {{ items.correo }}
          </p>
          <p color="primary">
            <span
              color="primary"
              class="font-weight-bold primary--text"
              v-text="'País: '"
            />
            {{
              items.ubicacion ? items.ubicacion.area_geografica.pais.nombre : ""
            }}
          </p>
          <p color="primary">
            <span
              color="primary"
              class="font-weight-bold primary--text"
              v-text="'Area geografica: '"
            />
            {{
              items.ubicacion ? items.ubicacion.area_geografica.descripcion : ""
            }}
          </p>
          <p color="primary">
            <span
              color="primary"
              class="font-weight-bold primary--text"
              v-text="'Ubicacion asignada: '"
            />
            {{ items.ubicacion.nombre }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="btnAling">
          <basic-btn
            v-if="!items.usuarioRed"
            block
            text="Cambiar contraseña"
            @click="$router.push('/client/ChangePassword')"
            style="margin-top: 30px;"
          />
        </v-col>
        <v-col cols="12" class="btnAling">
          <basic-btn
            block
            text="Cerrar sesión"
            @click="logout"
            style="margin-bottom: 30px;"
            colorBtn="grey darken-1"
            dark
          />
        </v-col>
      </v-row>
      <span
        class="versionText text-body-2"
        v-text="'Check In Linde | ' + version"
      />
    </v-card>
  </view-container>
</template>

<script>
import { ViewContainer, BasicBtn } from "@/components";
import { services } from "@/utils";
import VueJwtDecode from "vue-jwt-decode";
import { userImg } from "@/assets";

export default {
  name: "home",
  components: {
    ViewContainer,
    BasicBtn,
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    host: process.env.VUE_APP_API_SERVER,
    userImg: userImg,
    items: {
      numeroEmpleado: null,
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      login: "",
      correo: "",
      ingresaConNumEmpleado: false,
      puesto: "",
      idexterno: null,
      ubicacion: {
        ubicacionID: 0,
        codigo: "",
        nombre: "",
        area_geografica: {
          areaGeograficaID: 0,
          codigo: "",
          descripcion: "",
          pais: { paisID: 0, codigo: "", nombre: "" },
        },
      },
      departamento: { codigo: "1", nombre: "Administración" },
      usuarioRed: true,
      imgURI: null,
    },
    dimension: 0,
    rules: {},
    dialogs: {},
    links: {},
  }),
  mounted() {
    this.dataProfile();
    let info2 = VueJwtDecode.decode(this.$session.get("jwt"));
  },
  methods: {
    dataProfile() {
      services
        .ws("get", "profile")
        .then((res) => {
          if (res.ok) {
            this.items = res.data;
          } else {
          }
        })
        .catch((error) => {
          this.codeError = error.response.data.code;
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    logout() {
      if (this.$session.exists()) {
        let jwt = this.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        this.axios
          .post(services.routes.logout, null, { headers })
          .then((response) => {
            let res = response.data;
            this.$session.destroy();
            this.$router.push("/login");
          })
          .catch((error) => {
            this.$session.destroy();
            this.$router.push("");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push("");
      }
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}
.padding-t0 {
  padding-top: 0px;
}
.padding-t10 {
  padding-top: 10%;
}
.btnAling {
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 4%;
}
p {
  color: #005591;
}
.versionText {
  bottom: 0;
  position: absolute;
  color: grey;
  font-weight: bold;
}
</style>
